import React, {Component} from 'react';
import {Form, Row, Col} from 'react-bootstrap';
import {formatMoney} from "../../utils";

const parseMoney = (value) => {
	return ("" + value).replace(/\s/gi, '').replace(',', '.');
};

export default class MoneyField extends Component {

	constructor(props) {
		super(props);

		this.state = {
			numValue: null,
			isFocus: false
		};
	}

	componentDidMount() {
		this.setState({numValue: this.props.input.value});
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.props.input && this.props.input.value !== prevProps.input.value) {
			this.setState({numValue: this.props.input.value});
		}
	}

	render() {

		const {
			feedbackIcon,
			input,
			label,
			feedbackSuccess,
			meta: {error, warning, touched, asyncValidating},
			sizes,
			onChangeHook,
			...props
		} = this.props;

		const {numValue, isFocus} = this.state;

		let message;
		const validationState = touched ? (error && "danger") || (warning && "warning") || (!props.disabled && feedbackSuccess && input.value ? "success" : null) : null;
		// const icon = feedbackIcon ? feedbackIcon : ((!props.disabled && validationState === "success" && feedbackSuccess && input.value) ? <span className="fa fa-ok"/> : null)

		if (touched && (error || warning)) {
			message = error || warning
		}

		const formatted = isFocus
			? numValue
			: numValue || numValue === 0 ? formatMoney(1 * numValue, 2, 2) : "";

		const labelS = sizes && sizes[0] !== undefined ? sizes[0] : 4;
		const inputS = sizes && sizes[1] !== undefined ? sizes[1] : 8;
		return (
			<Form.Group as={Row} controlId={input.name} className={asyncValidating ? "loading" : ""}>
				{label && labelS ? <Form.Label column xs={labelS}>{label}</Form.Label> : null}
				<Col xs={inputS}>
					<Form.Control
						{...props}
						{...input}
						placeholder={input.placeholder ? input.placeholder : (!labelS && label ? label : null)}
						value={formatted}
						onFocus={() => {
							this.setState({isFocus: true})
						}}
						onChange={(value) => {
							const v = value.target.value;
							this.setState({numValue: parseMoney(v)});
							// return input.onChange(v);
						}}
						onBlur={() => {
							const v = this.state.numValue;
							if (onChangeHook) {
								onChangeHook(v)
							}
							this.setState({isFocus: false});
							return input.onBlur(v);
						}}
						className={"form-control text-right" + (touched ? (error ? " is-invalid" : (feedbackSuccess ? " is-valid" : "")) : "")}
					/>
					{message ? <div className={"text-" + validationState}>{message}</div> : null}
				</Col>
			</Form.Group>
		);
	}
}
